import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

// import { GSDevTools } from 'gsap/GSDevTools';
// gsap.registerPlugin(GSDevTools);

export default function eineuro() {
  const mm = gsap.matchMedia();

  gsap.set(
    '#euro_coin *, #chart, #euro_headlines, #chart_mobile, #euro_headlines_mobile',
    {
      opacity: 0
    }
  );

  gsap.set(
    '#overlay, #label20, #label19, #label18, #label5, #label38, #overlay_mobile, #label20_mobile, #label19_mobile, #label18_mobile, #label5_mobile, #label38_mobile',
    {
      visibility: 'hidden',
      opacity: 0
    }
  );

  gsap.set(
    '#liane7, #liane8, #euro_coin *, #liane7_mobile, #liane8_mobile, #euro_coin_mobile *',
    {
      drawSVG: 0
    }
  );
  // Desktop
  mm.add('(min-width: 960px)', () => {
    gsap.set('#Ebene_2_mobile', {
      display: 'none'
    });

    ScrollTrigger.create({
      trigger: '#abw_section_5',
      pin: '#abw_section_5',
      start: 'top top',
      end: '+=250%',
      scrub: true,
      anticipatePin: 1
    });

    gsap
      .timeline({
        defaults: {
          duration: 1,
          ease: 'none'
        },
        scrollTrigger: {
          trigger: '#abw_section_5',
          pin: false,
          scrub: true,
          onRefresh: (self) => self.progress && self.animation.progress(1),
          // anticipatePin: 0.5,
          start: 'top 50%',
          end: '+=350%'

          // markers: true,
          // id: 'Section 5'
        }
      })
      .fromTo('#liane7', { drawSVG: 0 }, { drawSVG: '100%' }, 0)
      .to('#euro_headlines', { opacity: 1 }, 0.25)
      .to('#euro_coin *', { opacity: 1 }, 1)
      .to('#euro_coin *', { drawSVG: true }, 1)
      .from('#euro_coin *', { fill: 'transparent' }, 2)
      .to('#euro_coin', { opacity: 0 }, 3.2)
      .to('#chart', { opacity: 1 }, 3.2)
      .to(
        '#overlay, #label20, #label19, #label18, #label5, #label38',
        { visibility: 'visible' },
        3.3
      )
      .from(
        '#cent38',
        {
          scale: 1.085,
          repeat: 2,
          yoyo: true,
          transformOrigin: 'center center'
        },
        3.3
      )
      .fromTo('#liane8', { drawSVG: 0 }, { drawSVG: '100%' }, 7.25);
  });

  // Mobile
  mm.add('(max-width: 959px)', () => {
    gsap.set('#Ebene_2', {
      display: 'none'
    });

    ScrollTrigger.create({
      trigger: '#abw_section_5',
      pin: '#abw_section_5',
      start: 'top top',
      end: '+=250%',
      scrub: true
      // anticipatePin: 1,
    });

    gsap
      .timeline({
        defaults: {
          duration: 1,
          ease: 'none'
        },
        scrollTrigger: {
          trigger: '#abw_section_5',
          pin: false,
          scrub: true,
          start: 'top 50%',
          end: '+=350%'
          // markers: true,
          // id: 'Section 5'
        }
      })
      .fromTo(
        '#liane7_mobile',
        { drawSVG: 0 },
        { drawSVG: '100%', ease: 'none' },
        0
      )
      .to('#euro_headlines_mobile', { opacity: 1 }, 0.25)
      .to('#euro_coin_mobile *', { drawSVG: true }, 1)
      .from('#euro_coin_mobile *', { fill: 'transparent' }, 2)
      .to('#euro_coin_mobile', { opacity: 0 }, 3.2)
      .to('#chart_mobile', { opacity: 1 }, 3.2)
      .to(
        '#overlay_mobile, #label20_mobile, #label19_mobile, #label18_mobile, #label5_mobile, #label38_mobile',
        { visibility: 'visible' },
        3.3
      )
      .from(
        '#cent38_mobile',
        {
          scale: 1.085,
          repeat: 2,
          yoyo: true,
          transformOrigin: 'center center'
        },
        3.3
      )
      .fromTo(
        '#liane8_mobile',
        { drawSVG: 0 },
        { drawSVG: '100%', duration: 2 },
        6.5
      );
  });
  showLabelHandler();
  // GSDevTools.create({ animation: euroTl });
}

function showLabelHandler() {
  const overlay = document.getElementById('overlay');
  const overlay_mobile = document.getElementById('overlay_mobile');
  const charts = [
    document.getElementById('chart'),
    document.getElementById('chart_mobile')
  ];

  if (!charts || !overlay) return;

  const chartLabels = {
    cent38: 'label38',
    cent19: 'label19',
    cent18: 'label18',
    cent20: 'label20',
    cent5: 'label5',
    cent38_mobile: 'label38_mobile',
    cent19_mobile: 'label19_mobile',
    cent18_mobile: 'label18_mobile',
    cent20_mobile: 'label20_mobile',
    cent5_mobile: 'label5_mobile'
  };

  charts.forEach((chart) => {
    chart.addEventListener(
      'mouseenter',
      (e) => {
        const labelElt = getElement(e);

        if (!labelElt) return;

        labelElt.style.opacity = 1;
        overlay.style.opacity = 0.98;
        overlay_mobile.style.opacity = 0.98;
      },
      true
    );

    chart.addEventListener(
      'mouseleave',
      (e) => {
        const labelElt = getElement(e);

        if (!labelElt) return;

        labelElt.style.opacity = 0;
        overlay.style.opacity = 0;
        overlay_mobile.style.opacity = 0;
      },
      true
    );
  });

  function getElement(e) {
    const hoveredElement = e.target.id;
    // console.log(hoveredElement);
    if (!hoveredElement) return;

    return document.getElementById(chartLabels[hoveredElement]);
  }
}
